import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../stili/NavbarStaff.css";

const gruppiStaff = [
  {
    nome: "Attività",
    voci: [
      { label: "Inserisci Allenamenti", path: "/gestionale1/allenamentiForm" },
      { label: "Aggiorna Allenamenti", path: "/gestionale1/aggiorna-allenamenti" },
      { label: "Report Allenamenti", path: "/gestionale1/allenamentiStaff" },
      { label: "Presenze Allenamento", path: "/gestionale1/presenzestaff" },
      { label: "Convocazioni", path: "/gestionale1/convocazioni" },
      { label: "Presenze Gara", path: "/gestionale1/presenze-gara-staff"},
      { label: "Risultato Gara", path: "/gestionale1/risultati-gara" }
    ]
  },
  {
    nome: "Statistiche",
    voci: [
      { label: "Statistiche Presenze Giocatori", path: "/gestionale1/statistiche-presenzestaff" },
      { label: "Statistiche Marcatori/AssistMan", path: "/gestionale1/statistiche-reti" }
    ]
  }
];

export default function NavbarStaff() {
  const navigate = useNavigate();
  const location = useLocation();

  const [openSidebar, setOpenSidebar] = useState(true);

  const gruppiIniziali = useMemo(() => {
    return gruppiStaff.reduce((acc, gruppo) => {
      const gruppoAttivo = gruppo.voci.some((voce) => location.pathname === voce.path);
      acc[gruppo.nome] = gruppoAttivo;
      return acc;
    }, {});
  }, [location.pathname]);

  const [openGroups, setOpenGroups] = useState(gruppiIniziali);

  useEffect(() => {
    setOpenGroups((prev) => {
      const next = { ...prev };

      gruppiStaff.forEach((gruppo) => {
        const gruppoAttivo = gruppo.voci.some((voce) => location.pathname === voce.path);
        if (gruppoAttivo) {
          next[gruppo.nome] = true;
        }
      });

      return next;
    });
  }, [location.pathname]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 900px)");

    const handleViewportChange = (event) => {
      setOpenSidebar(!event.matches);
    };

    setOpenSidebar(!mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleViewportChange);
      return () => mediaQuery.removeEventListener("change", handleViewportChange);
    } else {
      mediaQuery.addListener(handleViewportChange);
      return () => mediaQuery.removeListener(handleViewportChange);
    }
  }, []);

  const toggleSidebar = () => {
    setOpenSidebar((prev) => !prev);
  };

  const toggleGroup = (nomeGruppo) => {
    setOpenGroups((prev) => ({
      ...prev,
      [nomeGruppo]: !prev[nomeGruppo]
    }));
  };

  const isActive = (path) => location.pathname === path;

  const handleNavigate = (path) => {
    navigate(path);

    if (window.innerWidth <= 900) {
      setOpenSidebar(false);
    }
  };

  return (
    <>
      {!openSidebar && (
        <button
          type="button"
          className="staff-hamburger"
          aria-label="Apri menu"
          onClick={toggleSidebar}
        >
          <span />
          <span />
          <span />
        </button>
      )}

      <aside className={`staff-sidebar ${openSidebar ? "is-open" : "is-closed"}`}>
        <div className="staff-sidebar-inner">
          <div className="staff-sidebar-header">
            <div>
              <span className="staff-sidebar-badge">Area Staff</span>
              <h2>Gestionale Staff</h2>
            </div>

            <button
              type="button"
              className="staff-close-btn"
              aria-label="Chiudi menu"
              onClick={toggleSidebar}
            >
              ✕
            </button>
          </div>

          <div className="staff-sidebar-content">
            {gruppiStaff.map((gruppo) => (
              <div key={gruppo.nome} className="staff-nav-group">
                <button
                  type="button"
                  className="staff-group-toggle"
                  onClick={() => toggleGroup(gruppo.nome)}
                >
                  <span>{gruppo.nome}</span>
                  <span className={`staff-caret ${openGroups[gruppo.nome] ? "open" : ""}`}>
                    ▾
                  </span>
                </button>

                {openGroups[gruppo.nome] && (
                  <div className="staff-group-links">
                    {gruppo.voci.map((voce) => (
                      <button
                        key={voce.path}
                        type="button"
                        className={`staff-nav-link ${isActive(voce.path) ? "active" : ""}`}
                        onClick={() => handleNavigate(voce.path)}
                      >
                        {voce.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="staff-sidebar-footer">
            <small>© Gestione Staff</small>
          </div>
        </div>
      </aside>

      <div
        className={`staff-sidebar-overlay ${openSidebar ? "show" : ""}`}
        onClick={() => setOpenSidebar(false)}
      />
    </>
  );
}